import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  deleteANewsCat,
  getCategories,
  resetState,
} from "../features/CountrySclice";
import CustomModal from "../../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Country Name",
    dataIndex: "category_name"
  },

  {
    title: "Action",
    dataIndex: "action",
  },
];

const Newscatlist = () => {
  const [open, setOpen] = useState(false);
  const [NewsCatId, setNewsCatId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setNewsCatId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getCategories());
  }, []);
  const bCatState = useSelector((state) => state.country.bCategories);
  console.log(bCatState);
  const data1 = [];
  for (let i = 0; i < bCatState.length; i++) {
    data1.push({
      key: i + 1,
      category_name: bCatState[i].data.countryName,
      action: (
        <>
          <Link
            to={`/admin/Add-Country/${bCatState[i].data.id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(bCatState[i].data.id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNewsCategory = (e) => {
    dispatch(deleteANewsCat(e));
    setOpen(false);
    setTimeout(() => {
      dispatch(getCategories());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Country List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNewsCategory(NewsCatId);
        }}
        title="Are you sure you want to delete this  Country?"
      />
    </div>
  );
};

export default Newscatlist;
